import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchOrders } from '../store/slices/ordersSlice';
import './Orders.css';

const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items: orders, loading, error, pagination } = useSelector((state) => state.orders);
  

  const [sortField, setSortField] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');

 

  const formatDate = (s) => (s ? new Date(s).toLocaleString() : '—');
  const formatCurrency = (v, currency = 'USD') => {
    const amount = Number(v);
    return isNaN(amount) ? '—' : `${currency === 'USD' ? '$' : currency + ' '}${amount.toFixed(2)}`;
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '—');

  const sortedOrders = [...orders].sort((a, b) => {
    let aVal = a[sortField];
    let bVal = b[sortField];
    if (sortField === 'totalAmount') {
      aVal = Number(aVal);
      bVal = Number(bVal);
    }
    const comparison = aVal > bVal ? 1 : -1;
    return sortDirection === 'asc' ? comparison : -comparison;
  });

  const getStatusClass = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'processing': return 'processing';
      case 'confirmed': return 'processing';
      case 'completed':
      case 'delivered': return 'completed';
      case 'cancelled': return 'cancelled';
      case 'shipped': return 'processing';
      default: return 'pending';
    }
  };

  const getPaymentClass = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'completed':
      case 'paid': return 'paid';
      case 'refunded': return 'refunded';
      default: return 'pending';
    }
  };
  useEffect(() => {
    dispatch(fetchOrders({ limit: 50, skip: 0 }));
  }, [dispatch]);


  return (
    <div className="orders-container">
      <div className="orders-header">
        <div>
          <h1>Orders</h1>
          <p>
            View all orders with status and payment information
            {pagination.total > 0 && <span className="order-count"> ({pagination.total} total)</span>}
          </p>
        </div>
      </div>

      {error && (
        <div className="error-banner">
          <span>⚠️ {typeof error === 'string' ? error : error?.message || error?.error || 'Failed to load orders'}</span>
          <button onClick={() => dispatch(fetchOrders({ limit: 50, skip: 0 }))}>Retry</button>
        </div>
      )}

      {loading ? (
        <div className="loading-state">Loading orders…</div>
      ) : (
        <div className="orders-table-wrap">
          {sortedOrders.length === 0 ? (
            <div className="empty-state">
              <p>No orders yet. Orders placed via WhatsApp will appear here automatically.</p>
            </div>
          ) : (
            <table className="orders-table datatable">
              <thead>
                <tr>
                  <th onClick={() => handleSort('orderNumber')} className="sortable">
                    Order {sortField === 'orderNumber' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th onClick={() => handleSort('customerName')} className="sortable">
                    Customer {sortField === 'customerName' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th onClick={() => handleSort('totalAmount')} className="sortable">
                    Total {sortField === 'totalAmount' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th onClick={() => handleSort('status')} className="sortable">
                    Status {sortField === 'status' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th onClick={() => handleSort('paymentStatus')} className="sortable">
                    Payment {sortField === 'paymentStatus' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th>Invoice</th>
                  <th onClick={() => handleSort('createdAt')} className="sortable">
                    Created {sortField === 'createdAt' && <span className="sort-arrow">{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedOrders.map((order) => (
                  <tr key={order._id} className={order.status === 'cancelled' ? 'row-cancelled' : ''}>
                    <td><strong>{order.orderNumber}</strong></td>
                    <td>{order.customerName || order.customerPhone || '—'}</td>
                    <td className="amount">{formatCurrency(order.totalAmount, order.currency)}</td>
                    <td><span className={`status-badge ${getStatusClass(order.status)}`}>{capitalize(order.status)}</span></td>
                    <td><span className={`payment-badge ${getPaymentClass(order.paymentStatus)}`}>{capitalize(order.paymentStatus)}</span></td>
                    <td>
                      {order.invoiceId
                        ? <span className="invoice-badge invoice-generated" title="Invoice generated">🧾 Generated</span>
                        : <span className="invoice-badge invoice-none">—</span>
                      }
                    </td>
                    <td><small>{formatDate(order.createdAt)}</small></td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => navigate(`/orders/${order._id}`)}
                        title="View order details"
                      >
                        👁️ View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default Orders;

